import { Row, Col } from "react-bootstrap";
import cctvIcon from "../assets/images/cctv.svg";
import couchIcon from "../assets/images/couch.svg";
import swimmingPoolIcon from "../assets/images/pool.svg";
import powerIcon from "../assets/images/power.svg";
import utensilsIcon from "../assets/images/utensils.svg";
import terraceIcon from "../assets/images/balcony.svg";
import elevatorIcon from "../assets/images/elevator.svg";
import gymIcon from "../assets/images/gym.svg";
import cinemaIcon from "../assets/images/cinema.svg";
import astroturfIcon from "../assets/images/astroturf.svg";
import studyIcon from "../assets/images/study.svg";
import boxRoomIcon from "../assets/images/box-room.svg";
import securityIcon from "../assets/images/security.svg";
import playgroundIcon from "../assets/images/playground.svg";
import "../assets/scss/components/full-features.scss";

const FEATURES = {
    "18-24hr Power Supply": { icon: powerIcon, alt: "power icon" },
    "CCTV Cameras": { icon: cctvIcon, alt: "CCTV icon" },
    "Astroturf": { icon: astroturfIcon, alt: "Astroturf Icon" },
    "Box Room": { icon: boxRoomIcon, alt: "Box room icon" },
    "Cinema": { icon: cinemaIcon, alt: "Cinema Icon" },
    "Elevator": { icon: elevatorIcon, alt: "Elevator Icon" },
    "Family Lounge": { icon: couchIcon, alt: "Family Lounge Icon" },
    "Fully Fitted Kitchen": { icon: utensilsIcon, alt: "Kitchen Icon" },
    "Gym": { icon: gymIcon, alt: "Gym Icon" },
    "Kids' Play Area": { icon: playgroundIcon, alt: "Playground Icon" },
    "Secure & Gated Estate": { icon: securityIcon, alt: "Secure estate icon" },
    "Study": { icon: studyIcon, alt: "Study icon" },
    "Swimming Pool": { icon: swimmingPoolIcon, alt: "Swimming pool icon" },
    "Terrace Views": { icon: terraceIcon, alt: "Terrace icon" },
}

const FullFeatures = ({ features }) => {
    return (
        <Row as="ul" lg={3} className="d-flex flex-row align-items-center justify-content-center gap-3 full-features">
            {features &&
            features.map((featureKey, index) => {
                const feature = FEATURES[featureKey];

                return feature ? (
                    <Col as="li" key={index} xs={10} sm={7} md={5} lg={3} className="feature">
                        <img src={feature.icon} alt={feature.alt} width="48px" height="48px" />
                        <p className="mt-2 text-center text-sm font-medium">{featureKey}</p>
                    </Col>
                ) : null;
            })}
        </Row>
    )
}

export default FullFeatures;